import { BaseModelInternalId } from './types';

const baseModelsSet = new Set(Object.values(BaseModelInternalId));

export function isBaseModelId(modelId: string): modelId is BaseModelInternalId {
  return baseModelsSet.has(modelId as BaseModelInternalId);
}
